<template>
  <div>
    <div class="content-item flex align-items-center">
      <div class="content-item-label" v-if="articleType != 7"><span class="red">*</span>标题</div>
      <div class="content-item-label" v-if="articleType == 7"><span class="red">*</span>视频标题</div>
      <el-input
        show-word-limit
        maxlength="50"
        v-model="input"
        placeholder="请输入内容"
      ></el-input>
      <slot></slot>
    </div>
    <p class="tips">建议输入门诊时患者的常见问题；标题明确具体，患者一眼能看懂</p>
  </div>
</template>

<script>
export default {
  name: "title",
  props: ['articleType', 'title'],
  computed: {
    input: {
      get() {
        return this.title
      },
      set(val) {
        this.$emit('update:title',val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.article_tit {
  .el-input__suffix {
    left: 100% !important;
    right: auto !important;
  }
}
</style>
